<template>
  <div class="orm-html orm-plzoverlay orm-py-56">
    <div class="orm-container" v-click-outside="cancel">
      <div class="orm-row orm-mb-32 center-xs middle-xs">
        <div class="orm-col-xs-12 orm-col-lg-6 text-center">
          <h2 class="orm-headline__h1 orm-searchbar__title">
            {{
              i18n("modules/carcategory/titlePLZ") || "Wann soll es losgehen?"
            }}
          </h2>
        </div>
      </div>
      <div class="orm-row center-xs middle-xs" style="min-height: 250px">
        <div class="orm-col-xs-12 orm-col-sm-10 orm-col-lg-7">
          <div class="" v-if="step == 1">
            <div class="orm-row">
              <div class="orm-relative orm-col-xs-12 orm-col-md-5">
                <Datepicker
                  :start-only="true"
                  :infobar="false"
                  viewType="mapModule"
                />
              </div>
              <div
                class="orm-relative orm-col-xs-12 orm-col-md-4"
                v-if="!ownercode"
              >
                <form-input
                  class="orm-input orm-noborderRadius"
                  my-id="zipcode"
                  myType="text"
                  myPattern="[0-9]*[.|,]{0,}[0-9]{1,2}"
                  :my-label="i18n('search/label/zipcode') || 'PLZ'"
                  isRequired
                  :myPlaceholder="
                    i18n('search/label/zip_placeholder') || 'Ihre Postleitzahl'
                  "
                  v-model="plz"
                ></form-input>
              </div>
              <div class="orm-relative orm-col-xs-12 orm-col-md-3">
                <label class="orm-form__label" for="submit">&nbsp;</label>
                <button
                  class="orm-btn orm-btn--large"
                  :class="[!loading ? '' : 'disable']"
                  @click="getStations()"
                  v-if="plz.length >= 5 || ownercode"
                >
                  {{ i18n("search/label/btn_more") || "Weiter" }}
                </button>
                <button v-else class="orm-btn orm-btn--large orm-btn--disabled">
                  {{ i18n("search/label/btn_more") || "Weiter" }}
                </button>
              </div>
            </div>
            <div class="orm-row" v-if="abolength">
              <div class="orm-col-xs-12">
                <span class="orm-minabo_title"
                  >{{
                    i18n("search/label/minabo_title") || "Gewünschte Abo-Länge"
                  }}:
                </span>
                <SimpleSelect
                  :my-options="abolength"
                  :selected="selectedAbo"
                  @selected="selectAbo"
                />
              </div>
            </div>
          </div>
          <div class="step_2 orm-row" v-if="step == 2">
            <div class="orm-relative orm-col-xs-12 orm-col-sm-8">
              <label class="orm-form__label" for="haendlersuche">{{
                i18n("search/label/dealer_title") || "Händler"
              }}</label>
              <Stationpicker
                :data="stations"
                type="start"
                v-model:selectedstation="selectedStation"
              />
            </div>
            <div class="orm-relative orm-col-xs-12 orm-col-sm-4">
              <label class="orm-form__label" for="haendlersuche">&nbsp;</label>
              <button
                v-if="store.getters['userSession/GET_STATION']"
                @click="getCars('/reservation/step1')"
                class="orm-btn orm-btn--large"
                :class="[!loading ? '' : 'disable']"
              >
                <i v-if="loading" class="fa fa-spinner-third orm-rotate360"></i>
                {{ i18n("general/showOffers") }}
              </button>
              <button v-else class="orm-btn orm-btn--large orm-btn--disabled">
                {{ i18n("general/showOffers") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import routes from "@/router/index";
// eslint-disable-next-line
import store from "@/store";
import Datepicker from "@/components/ui/datepicker-startonly.vue"; // @ is an alias to /src
import FormInput from "@/components/ui/INPUTS/FormInputPLZ.vue"; // @ is an alias to /src
import Stationpicker from "@/components/ui/stationpicker-plz.vue"; // @ is an alias to /src
import SimpleSelect from "@/components/ui/INPUTS/SimpleSelect.vue"; // @ is an alias to /src
import { buildDataLayer } from "@/constants/analytics";

import i18n from "@/mixins/mixins";

export default {
  name: "modal-stationtimeselect",
  components: { Datepicker, FormInput, Stationpicker, SimpleSelect },
  emits: ["cancel"],
  props: {
    car: Object,
    showCategory: {
      type: Boolean,
      required: false,
      default: false,
    },
    noCarfilter: {
      type: Boolean,
      required: false,
      default: false,
    },
    ownercode: { required: false },
  },
  mixins: [i18n],
  data() {
    return {
      loading: false,
      selectedStation: null,
      plz: "",
      step: 1,
      stations: store.getters["stations/GET_STATIONS"],
      abolength: null,
      selectedAbo: null,
      modalopen: false,
    };
  },
  setup() {
    return {
      store,
    };
  },
  async mounted() {
    // console.log(this.car);
    // document.body.style.overflow = "hidden";
    this.abolength = await store.getters["reservation/GET_ABO_LENGTH"];
    this.selectedAbo = await store.getters["reservation/GET_SELECTEDABO"];
    setTimeout(() => {
      buildDataLayer("opened_carslidermodal");
    }, 100);
  },
  beforeUnmount() {
    // document.body.style.overflow = "unset";
  },
  methods: {
    cancel(ev) {
      if (
        !ev.target.classList.contains("orm-btn") &&
        !ev.target.classList.contains("vl-calendar-month__day") &&
        !ev.target.classList.contains("orm-stationselect__option") &&
        !ev.target.classList.contains("orm-plzoverlay") &&
        ev.target.classList.length > 0
      ) {
        this.$emit("cancel");
      }
    },
    async getCars() {
      if (this.selectedStation) {
        store.dispatch("userSession/SET_STATION", this.selectedStation);
      }
      buildDataLayer("set_dealer");
      // const cartype = this.car.category;
      buildDataLayer("show_offers");
      const times = await store.getters["stations/GET_OPENINGTIMES"];
      this.loading = true;
      if (times) {
        if (this.noCarfilter) {
          if (process.env.VUE_APP_STANDALONE === "true") {
            this.$router.push({ name: "Reservation_Step1" });
          } else {
            window.location.href =
              process.env.VUE_APP_BASE_URL +
              process.env.VUE_APP_RESERVATION_PATH +
              process.env.VUE_APP_RESERVATION_PATH_STEP1;
          }
          return false;
        }
        if (this.showCategory) {
          const group = {};
          group[this.car.category] = true;
          store.dispatch("userSession/SET_CARCATEGORY", group);
          if (process.env.VUE_APP_STANDALONE === "true") {
            this.$router.push({ name: "Reservation_Step1" });
          } else {
            window.location.href =
              process.env.VUE_APP_BASE_URL +
              process.env.VUE_APP_RESERVATION_PATH +
              process.env.VUE_APP_RESERVATION_PATH_STEP1;
          }
        } else {
          store.dispatch("userSession/SET_CARGROUP", this.car.id).then(() => {
            store.dispatch("reservation/DELETE_TARIF");
            store.dispatch("stations/SET_OPENINGTIMES").then(() => {
              store
                .dispatch("reservation/CALCULATE_PRICE", {
                  id: this.car.id,
                  extras: false,
                })
                .then((tarif) => {
                  // console.log(tarif);
                  // console.log(tarif.main_rates.length);
                  if (tarif.main_rates.length == 0) {
                    if (process.env.VUE_APP_STANDALONE == "true") {
                      this.$router.push({ name: "Reservation_Step1" });
                    } else {
                      window.location.href =
                        process.env.VUE_APP_BASE_URL +
                        process.env.VUE_APP_RESERVATION_PATH +
                        process.env.VUE_APP_RESERVATION_PATH_STEP1;
                    }
                  } else {
                    store
                      .dispatch("reservation/SET_RESERVATION_TARIFS", tarif)
                      .then(() => {
                        if (process.env.VUE_APP_STANDALONE == "true") {
                          this.$router.push({ name: "Reservation_Step2" });
                        } else {
                          window.location.href =
                            process.env.VUE_APP_BASE_URL +
                            process.env.VUE_APP_RESERVATION_PATH +
                            process.env.VUE_APP_RESERVATION_PATH_STEP2;
                        }
                      });
                  }
                });
            });
          });
        }
      }
    },
    getStations() {
      const cartype = this.car.category;
      const time = store.getters["userSession/GET_RESERVATIONDATE_START"];
      const plz = this.plz;
      buildDataLayer("search_dealer", cartype + "|" + time + "|" + plz);

      if (!this.ownercode) {
        store.dispatch("stations/GET_STATION_FROM_PLZ", this.plz).then(() => {
          this.step = 2;
          this.stations = store.getters["stations/GET_STATIONS"];
        });
      } else {
        store
          .dispatch("stations/GET_STATION_WITH_OWNERCODE", this.ownercode)
          .then(() => {
            this.step = 2;
            this.stations = store.getters["stations/GET_STATIONS"];
          });
      }
    },
    selectAbo(abo) {
      store.dispatch("reservation/SET_ABOLENGTH", abo);
      store.dispatch("stations/SET_OPENINGTIMES");
    },
  },
};
</script>
